const deliveryConfirmationHR = {
    "view": {
        "table": {
            "title": "Popis Dostavljenih",
            "columns": {
                "release": "Izdanje",
                "upc": "UPC Broj",
                "action": "Akcija",
                "status": "Status",
                "deliveryDate": "Datum Dostave",
                "details": "Detalji"
            },
            "label": {
                "statusDelivered": "DOSTAVLJENO",
                "statusPartially": "DJELIMIČNO",
                "statusUndelivered": "NEDOSTAVLJENO",
                "ddexActionInsert": "UBACI",
                "ddexActionFullUpdate": "POTPUNA AŽURIRANJA",
                "ddexActionMetadataUpdate": "META. AŽURIRANJE",
                "ddexActionTakedown": "UKLANJANJE"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "button": {
                "open": "OTVORI",
                "exportCSV": "Izvezi CSV"
            }
        }
    },
    "breakdownView": {
        "table": {
            "title": "Popis Dostava Trgovina",
            "column": {
                "store": "Trgovina",
                "additionalNote": "Dodatne Napomene",
                "status": "Status"
            },
            "label": {
                "statusDelivered": "DOSTAVLJENO",
                "statusUndelivered": "NEDOSTAVLJENO"
            },
            "button": {
                "exportCSV": "Izvezi CSV"
            },
            "message": {
                "appleSubjectToQC": "Uspješno dostavljeno, podložno dodatnoj QC kontroli od strane Apple Music osoblja.",
                "releaseDeliverySuccessfull": "Izdanje je uspješno dostavljeno na {{dspName}} servere",
                "releaseDeliveryUnsuccessfull": "Dostava izdanja nije bila uspješna za {dspName}.",
                "noDeliveriesPossible": "Trenutno nisu moguće dostave"
            }
        }
    }
};

export default deliveryConfirmationHR;